export default {
    name: 'Error404-Module',
    metaInfo: function() {
		return {
			title: this.$t('notFound.title'),
		}
	}
}